// extracted by css-extract-rspack-plugin
export default {"centeredFooterItem":"ActivityFilterBar-module__centeredFooterItem__jsHS4"};